import { getAssignableUsers, getJobAssignedRecruiters, assignJobToOthers } from '../../../../services/popupApi';

export const api = {
  getOptions: async (field) => {
    if (field.fetchOptionsKey === 'assignToUsers') return getAssignableUsers();
    return [];
  },
  loadExtraData: async (context) => getJobAssignedRecruiters(context.selectedIds[0]),
  submit: async (values, context, { removedIds, extraData }) => {
    await assignJobToOthers({
      jobIds: context.selectedIds,
      userId: values.assignToUserId,
      rate: values.candidateRate,
      priority: values.priority,
      removedIds,
      existingRecruiters: extraData?.recruitersData,
    });
  },
};
